import React from "react";
import "../HomePageDivider/HomePageDivider.css";

const HomePageDivider = (props) => {
  return (
    <section className="divider">
      <div
        role="img"
        aria-label={props.title || "Divider Image"}
        style={{
          backgroundImage: `url(${props.DividerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "400px",
        }}
      >
        <article className="divider-text">
          <h2>{props.title}</h2>
          <p>{props.description}</p>
        </article>
      </div>
    </section>
  );
};

export default HomePageDivider;
